export const FEATURE_FLAG_SIMPLE_DOCUMENT_IMPORT = 'simple_document_import';
export const FEATURE_FLAG_WIZARD_IMPORT_BUTTON = 'wizard_import_button';
